import { CircularProgress, Grid, Stack, Typography } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'

export default function Loading({ text }) {
    const { t } = useTranslation()
    return (
        <Grid container sx={{ width: 1, height: 1 }} alignContent='center' justifyContent='center'>
            <Stack alignItems='center' spacing={2}>
                <CircularProgress color="primary" />
                {!!text &&
                    <Typography variant='h6' color='textSecondary' align='center'>{t(text)}</Typography>
                }
            </Stack>
        </Grid>
    )
}
